










import { notEmptyString } from '@/api/validators';
import { SiteState, Snippet } from '@/store/types';
import { Component, Prop, Vue } from "vue-property-decorator";
import { State } from 'vuex-class';

@Component
export default class SnippetItem extends Vue {
  @Prop({ default: "site" }) section: string;
  @Prop({ default: "" }) name: string;
  @Prop({ default: false }) cleanSpacing: boolean;
  @State("site") site: SiteState;

  get snippet(): Snippet {
    const key = [this.section, this.name].join("__");
    const item = this.site.snippets.find(sn => sn.key === key);
    const snippet = {format: "text", value: "", key: ""};
    if (item instanceof Object) {
      Object.entries(item).forEach(entry => {
        const [key,val] = entry;
        if (typeof val === "string") {
          switch (key) {
            case "format":
            case "value":
            case "key":
              snippet[key] = val;
              break;
          }
        }
      })
    }
    return snippet;
  }

  get format() {
    return this.snippet.format;
  }

  get isHtml() {
    return this.format === "html";
  }

  get content() {
    let str = "";
    if (notEmptyString(this.snippet.value)) {
      str = this.cleanSpacing && this.isHtml? this.cleanExtra(this.snippet.value) : this.snippet.value;
    }
    return str;
  }

  cleanExtra(str: string) {
    return str.replace(/<p[^>]*?>\s*<br[^>]*?>\s*<\/p>/g, '');
  }

}
